import axios from 'axios';
import { API_BASE_URL } from './scanApi';
import { getToken } from './authApi';

const base = `${API_BASE_URL}/admin/risks`;

// Chaque appel admin porte le token Bearer OpenIddict.
const cfg = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const listRisks = () => axios.get(base, cfg());
export const createRisk = (data) => axios.post(base, data, cfg());
export const updateRisk = (appId, data) => axios.put(`${base}/${appId}`, data, cfg());
export const deleteRisk = (appId) => axios.delete(`${base}/${appId}`, cfg());
export const importSeed = () => axios.post(`${base}/import`, {}, cfg());

// Stats scans pour le dashboard (granularity: day|week|month|year, from/to ISO optionnels).
export const getScanStats = ({ granularity = 'day', from, to } = {}) =>
  axios.get(`${API_BASE_URL}/admin/stats/scans`, {
    ...cfg(),
    params: { granularity, from, to },
  });

// Souscriptions / résiliations par période (mêmes paramètres que les scans).
export const getSubscriptionStats = ({ granularity = 'day', from, to } = {}) =>
  axios.get(`${API_BASE_URL}/admin/stats/subscriptions`, {
    ...cfg(),
    params: { granularity, from, to },
  });

// Instantané : abonnés actifs + répartition mensuel/annuel.
export const getSubscriptionSummary = () =>
  axios.get(`${API_BASE_URL}/admin/stats/subscriptions/summary`, cfg());

// Visiteurs uniques par période (+ répartition par pays) — mêmes paramètres que les scans.
export const getVisitStats = ({ granularity = 'day', from, to } = {}) =>
  axios.get(`${API_BASE_URL}/admin/stats/visits`, {
    ...cfg(),
    params: { granularity, from, to },
  });

// Événements de tunnel (clic Steam, démo) sur la période -> pour le funnel de conversion.
export const getEventStats = ({ from, to } = {}) =>
  axios.get(`${API_BASE_URL}/admin/stats/events`, { ...cfg(), params: { from, to } });

// Boite de réception support (messages du formulaire de contact).
export const getContacts = () => axios.get(`${API_BASE_URL}/admin/contacts`, cfg());
export const markContactRead = (id) =>
  axios.post(`${API_BASE_URL}/admin/contacts/${id}/read`, {}, cfg());
export const replyContact = (id, message) =>
  axios.post(`${API_BASE_URL}/admin/contacts/${id}/reply`, { message }, cfg());
export const deleteContact = (id) => axios.delete(`${API_BASE_URL}/admin/contacts/${id}`, cfg());

// Liens de préservation (modération admin).
export const listRescue = () => axios.get(`${API_BASE_URL}/admin/rescue`, cfg());
export const createRescue = (data) => axios.post(`${API_BASE_URL}/admin/rescue`, data, cfg());
export const updateRescue = (id, data) => axios.put(`${API_BASE_URL}/admin/rescue/${id}`, data, cfg());
export const deleteRescue = (id) => axios.delete(`${API_BASE_URL}/admin/rescue/${id}`, cfg());

// Avis utilisateurs (modération admin).
export const listReviews = () => axios.get(`${API_BASE_URL}/admin/reviews`, cfg());
export const setReviewHidden = (id, hidden) =>
  axios.patch(`${API_BASE_URL}/admin/reviews/${id}`, { hidden }, cfg());
export const deleteReview = (id) => axios.delete(`${API_BASE_URL}/admin/reviews/${id}`, cfg());

// Interrupteur Pro (dev/admin) : liste des users + lecture/écriture du statut Pro (sans Stripe).
export const listUsers = () => axios.get(`${API_BASE_URL}/admin/users`, cfg());
export const getUserPro = (steamId) =>
  axios.get(`${API_BASE_URL}/admin/users/pro`, { ...cfg(), params: { steamId } });
export const setUserPro = (steamId, isPro) =>
  axios.post(`${API_BASE_URL}/admin/users/pro`, { steamId, isPro }, cfg());
